"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSection = void 0;
var React = require("react");
var Grid_1 = require("../Grid");
var Button_1 = require("../Button");
var TextField_1 = require("../TextField");
var Badge_1 = require("../Badge");
var index_1 = require("../../theme/index");
var Dropdown_1 = require("../Dropdown");
var uniq_1 = require("../../utils/uniq");
var sortAlphabeticallyBy_1 = require("../../utils/sortAlphabeticallyBy");
var spacer_1 = require("../../utils/spacer");
var guid_1 = require("../../utils/guid");
var runOptionsBuilders_1 = require("../Grid/runOptionsBuilders");
var keyInitialFilters = function (initialFilters) { return initialFilters.map(function (f) {
    f.key = guid_1.guid();
    if (Array.isArray(f.options)) {
        f.options.forEach(function (fo) {
            fo.key = guid_1.guid();
        });
    }
    return f;
}); };
var FilterSection = /** @class */ (function (_super) {
    __extends(FilterSection, _super);
    function FilterSection(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholder = 'Select an attribute...';
        _this.filterSelected = function (e, _a) {
            var value = _a.value;
            var filter = (_this.state.filters || []).filter(function (f) { return f.value === value; });
            if (filter) {
                _this.setState({ targetFilter: filter[0] });
            }
        };
        _this.onTextFilterValueChanged = function (event) {
            _this.setState({
                targetFilterValue: event.target.value
            });
        };
        _this.onDropdownFilterValueChanged = function (_, option) {
            _this.setState({
                targetFilterValue: option.value
            });
        };
        _this.renderFilterSelection = function () {
            var _a = _this.state, filters = _a.filters, selectedFilters = _a.selectedFilters, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
            var _b = _this.props, onFilterCloseClicked = _b.onFilterCloseClicked, multipleDropdowns = _b.multipleDropdowns, _c = _b.closable, closable = _c === void 0 ? true : _c;
            return (React.createElement("div", { style: {
                    background: index_1.colors.black05,
                    borderRadius: index_1.spacing.micro,
                    padding: index_1.spacing.tiny,
                    marginBottom: index_1.spacing.tiny,
                    height: '8.33rem'
                } },
                React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                    React.createElement("h6", { style: { margin: "0 0 " + index_1.spacing.mini + " 0" } }, _this.props.title),
                    closable && React.createElement("img", { style: { cursor: 'pointer' }, onClick: function (event) { return onFilterCloseClicked(event, {
                            selectedFilters: selectedFilters,
                            targetFilter: targetFilter,
                            targetFilterValue: targetFilterValue,
                        }); }, src: require('../../../assets/close.svg') })),
                filters && filters.length > 0 ? (React.createElement("div", { style: { display: 'flex' } }, !multipleDropdowns
                    ?
                        _this.renderBasicDropdownSection()
                    :
                        _this.renderDropdownsForFiltersWithOptions())) : (React.createElement("span", null, "No remaining filters"))));
        };
        _this.renderSelectedFilters = function () {
            var selectedFilters = _this.state.selectedFilters;
            return (React.createElement(React.Fragment, null, selectedFilters &&
                selectedFilters.length > 0 &&
                selectedFilters.map(function (filter) { return (React.createElement(Badge_1.default, { key: filter.key, style: { marginRight: '0.33rem', cursor: 'pointer' }, textWeight: "light", onClick: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.removeFilter(filter)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); } },
                    filter.type === Grid_1.FilterType.TextMatch && (React.createElement("span", { style: { verticalAlign: 'top' } },
                        filter.label,
                        " contains \"",
                        (filter.getValueLabel && filter.getValueLabel(filter)) ||
                            filter.value.toString(),
                        "\"",
                        React.createElement("img", { style: { marginLeft: '0.66rem', height: '1.33rem' }, src: require('../../../assets/remove.svg') }))),
                    filter.type === Grid_1.FilterType.ListSelection && (React.createElement("span", { style: { verticalAlign: 'top' } },
                        filter.label,
                        " = \"",
                        (filter.getValueLabel && filter.getValueLabel(filter)) ||
                            filter.value.toString(),
                        "\"",
                        React.createElement("img", { style: { marginLeft: '0.66rem', height: '1.33rem' }, src: require('../../../assets/remove.svg') }))))); })));
        };
        if (Array.isArray(props.initialFilters) && props.initialFilters.length) {
            runOptionsBuilders_1.runOptionsBuilders(keyInitialFilters(props.initialFilters), props.data, { rekey: false, shouldUniqifyOptions: !!_this.props.makeTargetOptionsUnique });
        }
        _this.state = {
            filters: props.initialFilters,
            targetFilter: undefined,
            filtering: false,
            selectedFilters: props.intitialSelectedFilters || [],
        };
        return _this;
    }
    FilterSection.prototype.render = function () {
        return (React.createElement("div", null,
            this.renderFilterSelection(),
            this.renderSelectedFilters()));
    };
    FilterSection.prototype.renderBasicDropdownSection = function () {
        var _this = this;
        var _a = this.state, filters = _a.filters, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
        var filterToAdd;
        if (targetFilter && targetFilterValue && Array.isArray(targetFilter.options)) {
            filterToAdd = __assign(__assign({}, targetFilter.options.find(function (o) { return o.value === targetFilterValue; })), { label: targetFilter.label, type: targetFilter.type });
        }
        else {
            filterToAdd = __assign(__assign({}, targetFilter), { value: targetFilterValue });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown_1.Dropdown, { placeholder: this.placeholder, onChange: this.filterSelected, options: filters
                    ? filters.map(function (f) { return ({
                        key: f.key,
                        text: f.label,
                        value: f.value,
                        disabled: _this.shouldDisableFilter(f),
                    }); })
                    : [], value: (targetFilter === null || targetFilter === void 0 ? void 0 : targetFilter.value) || null }),
            targetFilter && (React.createElement(React.Fragment, null,
                React.createElement("span", { style: {
                        color: index_1.colors.black75,
                        fontWeight: 'bold',
                        margin: '0.66rem 0.66rem 0 0.66rem'
                    } }, targetFilter.type === Grid_1.FilterType.TextMatch
                    ? 'contains'
                    : 'equals'),
                targetFilter.type === Grid_1.FilterType.TextMatch ? (React.createElement(TextField_1.TextField, { onChange: this.onTextFilterValueChanged, placeholder: "Value...", value: targetFilterValue || undefined })) : (React.createElement("span", { style: this.props.targetDropdownStyle || {} },
                    React.createElement(Dropdown_1.Dropdown, { options: targetFilter.options || [], onChange: this.onDropdownFilterValueChanged, placeholder: "Value...", value: targetFilterValue || undefined, search: !!this.props.useTypeahead, fluid: true }))),
                React.createElement("div", { style: { marginLeft: '0.66rem' } },
                    React.createElement(Button_1.Button, { onClick: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.addFilter(filterToAdd)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); }, disabled: !targetFilterValue, variant: "primary", size: "small" }, "Add Filter"))))));
    };
    FilterSection.prototype.shouldDisableFilter = function (filter) {
        var disableFilter = this.props.disableFilter;
        var _a = this.state, filters = _a.filters, selectedFilters = _a.selectedFilters;
        if (typeof filter.disableWhen === 'function') {
            return filter.disableWhen({ filters: filters, selectedFilters: selectedFilters });
        }
        else if (typeof disableFilter === 'function') {
            return disableFilter({ filters: filters, selectedFilters: selectedFilters, filter: filter });
        }
        else {
            return Array.isArray(filter.options) && filter.options.length === 0;
        }
    };
    FilterSection.prototype.renderDropdownsForFiltersWithOptions = function () {
        var _this = this;
        var filters = this.state.filters;
        var filtersWithOptions = filters.filter(function (f) { return Array.isArray(f.options); });
        return (React.createElement(React.Fragment, null, filtersWithOptions.map(function (filter) { return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown_1.Dropdown, { asSelectButton: true, placeholder: filter.label, label: filter.label, onItemClick: function (_a) {
                    var option = _a.option;
                    return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, this.addFilterToSelectedFilters(filter, option)];
                            case 1: return [2 /*return*/, _b.sent()];
                        }
                    }); });
                }, disabled: _this.shouldDisableFilter(filter), options: filter.options
                    ?
                        filter.options.map(function (o) { return ({
                            key: o.key,
                            text: o.value,
                            value: o.value,
                        }); })
                    :
                        [] }),
            spacer_1.spacer(3))); })));
    };
    FilterSection.prototype.addFilterToSelectedFilters = function (filter, option) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedFilters, updatedFilters;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedFilters = this.state.selectedFilters;
                        updatedFilters = uniq_1.uniq(selectedFilters.concat(__assign(__assign({}, option), { type: filter.type, label: filter.label })));
                        return [4 /*yield*/, this.runBeforeHook('FilterApplied')];
                    case 1:
                        _a.sent();
                        this.setState({
                            selectedFilters: updatedFilters,
                        }, function () {
                            _this.removeOptionFromDropdown(filter, option);
                            _this.runAfterHook('FilterApplied');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterSection.prototype.removeOptionFromDropdown = function (filter, option) {
        var _a = this.props, _b = _a.multipleDropdowns, multipleDropdowns = _b === void 0 ? false : _b, _c = _a.removeOptionsAsUsed, removeOptionsAsUsed = _c === void 0 ? true : _c;
        if (!removeOptionsAsUsed) {
            return;
        }
        var filters = this.state.filters;
        var newFilters = [];
        if (multipleDropdowns) {
            newFilters = filters.map(function (f) {
                if (f.value === filter.value) {
                    f.options = f.options.filter(function (fo) { return fo.value !== option.value; });
                }
                return f;
            });
        }
        else {
            newFilters = __spreadArray([], filters);
            newFilters.forEach(function (f) {
                if (!Array.isArray(f.options) || f.options.length < 1) {
                    return;
                }
                if (f.key === filter.key) {
                    f.options = f.options.filter(function (fo) { return fo.value !== option; });
                }
            });
        }
        this.setFilters(newFilters);
    };
    FilterSection.prototype.runBeforeHook = function (hookName) {
        return __awaiter(this, void 0, void 0, function () {
            var func, _a, selectedFilters, targetFilter, targetFilterValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        func = this.props['before' + hookName];
                        if (typeof func !== 'function') {
                            return [2 /*return*/];
                        }
                        _a = this.state, selectedFilters = _a.selectedFilters, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
                        return [4 /*yield*/, func({ targetFilter: targetFilter, targetFilterValue: targetFilterValue, selectedFilters: selectedFilters })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterSection.prototype.removeFilter = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedFilters;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedFilters = this.state.selectedFilters;
                        return [4 /*yield*/, this.runBeforeHook('FilterRemoved')];
                    case 1:
                        _a.sent();
                        this.setState({
                            selectedFilters: selectedFilters.filter(function (f) { return f.key !== filter.key; })
                        }, function () {
                            _this.makeOptionAvailableToDropdown(filter);
                            _this.runAfterHook('FilterRemoved');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterSection.prototype.makeOptionAvailableToDropdown = function (filter) {
        var _a = this.props, _b = _a.multipleDropdowns, multipleDropdowns = _b === void 0 ? false : _b, _c = _a.removeOptionsAsUsed, removeOptionsAsUsed = _c === void 0 ? true : _c;
        if (!removeOptionsAsUsed) {
            return;
        }
        if (!multipleDropdowns) {
            this.addBackOptionSingleDropdown(filter);
        }
        else {
            this.addBackOptionMultipleDropdowns(filter);
        }
    };
    FilterSection.prototype.addBackOptionSingleDropdown = function (filter) {
        var newFilters = this.state.filters.map(function (f) {
            if (!Array.isArray(f.options)) {
                return f;
            }
            if (f.label !== filter.label) {
                return f;
            }
            var newList = f.options.concat({ value: filter.value, text: filter.value, key: filter.key });
            f.options = sortAlphabeticallyBy_1.sortAlphabeticallyBy(newList, 'value');
            return f;
        });
        this.setFilters(newFilters);
    };
    FilterSection.prototype.addBackOptionMultipleDropdowns = function (filter) {
        var newFilters = this.state.filters.map(function (f) {
            if (f.label !== filter.label) {
                return f;
            }
            if (Array.isArray(f.options)) {
                f.options = sortAlphabeticallyBy_1.sortAlphabeticallyBy(f.options.concat(filter), 'value');
                return f;
            }
            return f;
        });
        this.setFilters(newFilters);
    };
    FilterSection.prototype.setFilters = function (newFilters) {
        this.setState({
            filters: newFilters,
        });
    };
    FilterSection.prototype.isTextMatchAndHasAlreadyBeenAdded = function (filter) {
        var selectedFilters = this.state.selectedFilters;
        if (filter.type !== 0) {
            return false;
        }
        for (var i = 0; i < selectedFilters.length; i++) {
            if (selectedFilters[i].label === filter.label && selectedFilters[i].value === filter.value) {
                return true;
            }
        }
        return false;
    };
    FilterSection.prototype.addFilter = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, filters, selectedFilters, targetFilter, newFilter, newSelectedFilters, newState;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, filters = _a.filters, selectedFilters = _a.selectedFilters, targetFilter = _a.targetFilter;
                        newFilter = __assign({}, filter);
                        if (this.isTextMatchAndHasAlreadyBeenAdded(filter)) {
                            this.setState({
                                targetFilter: undefined,
                                targetFilterValue: undefined,
                            });
                            return [2 /*return*/];
                        }
                        if (filter.type === 0) {
                            newFilter = __assign(__assign({}, newFilter), { key: guid_1.guid() });
                        }
                        return [4 /*yield*/, this.runBeforeHook('FilterApplied')];
                    case 1:
                        _b.sent();
                        newSelectedFilters = selectedFilters.concat(newFilter);
                        newState = {
                            selectedFilters: newSelectedFilters,
                            targetFilter: undefined,
                            targetFilterValue: undefined,
                        };
                        if (targetFilter && Array.isArray(targetFilter.options)) {
                            newState = __assign(__assign({}, newState), { filters: this.removeUsedSelections(filters, newSelectedFilters) });
                        }
                        this.setState(newState, function () {
                            _this.runAfterHook('FilterApplied');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterSection.prototype.removeUsedSelections = function (filters, selectedFilters) {
        var _a = this.props.removeOptionsAsUsed, removeOptionsAsUsed = _a === void 0 ? true : _a;
        if (!removeOptionsAsUsed) {
            return filters;
        }
        var selectedFilterValues = selectedFilters.filter(function (filter) { return filter.type === 1; }).map(function (filter) { return filter.value; });
        var valuesAlreadyUsed = function (option) { return selectedFilterValues.indexOf(option.value) === -1; };
        return filters.map(function (filter) {
            if (filter.options && Array.isArray(filter.options) && filter.options.length) {
                filter.options = filter.options.filter(valuesAlreadyUsed);
            }
            return filter;
        });
    };
    FilterSection.prototype.runAfterHook = function (hookName) {
        var func = this.props['after' + hookName];
        if (typeof func !== 'function') {
            return;
        }
        var _a = this.state, selectedFilters = _a.selectedFilters, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
        func({ targetFilter: targetFilter, targetFilterValue: targetFilterValue, selectedFilters: selectedFilters });
    };
    return FilterSection;
}(React.Component));
exports.FilterSection = FilterSection;
//# sourceMappingURL=index.js.map